import {Component, OnInit, Optional} from '@angular/core';
import {TableHeaderService} from '../../services/table-header.service';
import {LoaderService} from '../../services/loader.service';
import {StoreVersionService} from '../../services/store-version.service';
import {ITableHeader} from '../../../interfaces/table-header';
import {TableEntityExtension} from "../../extensions/table-entity-extension/table-entity.extension";
import {FormBuilder, Validators} from "@angular/forms";
import {TableEntityExtensionService} from "../../extensions/table-entity-extension/table-entity-extension.service";
import {ActivatedRoute} from "@angular/router";
import {CardService} from "../../components/card/card.service";
import {FormService} from '../../services/form.service';
import {GuardService} from '../../services/guard.service';
import {UrlService} from '../../services/url.service';
import {MimeTypeConfig} from "../../../configs/mime-type.config";

@Component({
  selector: 'table-store-version',
  templateUrl: './table-store-version.component.html',
  providers: [LoaderService]
})
export class TableStoreVersionComponent extends TableEntityExtension implements OnInit {

  headers: ITableHeader[] = [
    this.tableHeaderService.id(),
    this.tableHeaderService.version(),
    this.tableHeaderService.createdAt(),
    this.tableHeaderService.updatedAt(),
  ];

  query: any = {
   order: null,
    filters: {}
  };

  acceptedFiles: string = MimeTypeConfig.zip;
  urlFilesUpload = '/api/v1/store-version/upload';
  platformApple = 'apple';
  platformGoogle = 'google';
  collapsePreloader: boolean = false;

  constructor(public loaderService: LoaderService,
              protected route: ActivatedRoute,
              protected modelService: StoreVersionService,
              protected tableEntityExtensionService: TableEntityExtensionService,
              @Optional() protected cardService: CardService,
              private tableHeaderService: TableHeaderService,
              private formService: FormService,
              private urlService: UrlService,
              private guardService: GuardService) {
    super(
      modelService,
      cardService,
      loaderService,
      tableEntityExtensionService,
      route
    );
    this.urlFilesUpload = this.urlService.uploadAddressable();
  }

  ngOnInit(): void {
    this.routesInit('store-versions');
  }

  async initForm(itemCollapse: any) {
    const skipChanges = await this.guardService.skipChanges();

    if (!skipChanges || itemCollapse.result) return;

    this.collapsePreloader = true;
    const item = this.source[itemCollapse.position];
    const form = this.forms[item.id] = new FormBuilder().group({
      version: [null, Validators.required],
      appleAddressable: [],
      googleAddressable: []
    });


    let data = await this.modelService.asyncGet({
      id: item.id,
      relations: ['appleAddressable', 'googleAddressable', 'store']
    });
    form.patchValue(data);
    this.collapsePreloader = false;
    this.formService.setDefaultValues(form);
    this.formService.setActiveForms([form]);

    itemCollapse.next();
  }
  async cancel(collapse) {
    const skipChanges = await this.guardService.skipChanges();
    if (skipChanges) this.formService.setForceSkipCheck()
    if (!skipChanges || collapse.result) return;

    collapse.toggle();
  }
}
